const PUBLIC_CMS_BASE = 'https://api.dev.auxo.dk/public'

export async function fetchCmsCollection(collectionName, params = {}) {
  try {
    const query = new URLSearchParams()
    if (params.limit) query.append('limit', params.limit)
    if (params.offset) query.append('offset', params.offset)
    if (params.sort) query.append('sort', params.sort)
    if (params.order) query.append('order', params.order)
    if (params.term) {
      if (Array.isArray(params.term)) {
        params.term.forEach(t => query.append('term', t))
      } else {
        query.append('term', params.term)
      }
    }

    const queryString = query.toString() ? `?${query.toString()}` : ''
    const response = await fetch(`${PUBLIC_CMS_BASE}/v2/content/${collectionName}${queryString}`)
    if (!response.ok) {
      const fallbackRes = await fetch(`${PUBLIC_CMS_BASE}/content/${collectionName}`)
      if (fallbackRes.ok) {
        const items = await fallbackRes.json()
        return { items: Array.isArray(items) ? items : [], total: items.length || 0 }
      }
      return { items: [], total: 0 }
    }
    const data = await response.json()
    return {
      items: data.items || [],
      total: data.total || 0,
      limit: data.limit,
      offset: data.offset
    }
  } catch (err) {
    console.warn(`Could not fetch CMS collection '${collectionName}':`, err)
    return { items: [], total: 0 }
  }
}
